import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';

const API = '/api';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const handleSubmit = async () => {
    if (!password || !password2) return;
    if (password !== password2) {
      setMessage({ type: 'error', text: 'Passwörter stimmen nicht überein' });
      return;
    }
    if (password.length < 6) {
      setMessage({ type: 'error', text: 'Passwort muss mindestens 6 Zeichen haben' });
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setMessage({ type: 'success', text: '✅ Passwort erfolgreich geändert!' });
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.error || 'Token ungültig oder abgelaufen' });
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div style={{ maxWidth: '420px', margin: '4rem auto', padding: '0 1rem' }}>
        <div className="card" style={{ textAlign: 'center' }}>
          <p style={{ color: '#e53e3e' }}>❌ Ungültiger Reset-Link</p>
          <Link to="/login" style={{ color: '#4c51bf' }}>Zurück zum Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '420px', margin: '4rem auto', padding: '0 1rem' }}>
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <div style={{ fontSize: '3rem' }}>🔐</div>
        <h1 style={{ color: '#4c51bf', marginTop: '0.5rem' }}>Neues Passwort</h1>
        <p style={{ color: '#718096' }}>Gib dein neues Passwort ein</p>
      </div>

      <div className="card">
        <input
          type="password"
          placeholder="Neues Passwort (min. 6 Zeichen)"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder="Passwort wiederholen"
          value={password2}
          onChange={e => setPassword2(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
        />

        {message && (
          <div className={`message message-${message.type}`}>{message.text}</div>
        )}

        <button className="btn-primary" style={{ width: '100%' }} onClick={handleSubmit} disabled={loading}>
          {loading ? 'Speichere...' : 'Passwort speichern'}
        </button>

        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
          <Link to="/login" style={{ color: '#4c51bf', fontSize: '0.9rem' }}>
            Zurück zum Login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;